/**
 *
 * 施工模拟
 *
 * 功能点:施工模拟
 * 场景:方案演示
 * 版本 1.0
 *
 */
import Vue from "@/main";
import * as modelMap from "@/views/index/map.js";
/**
 *
 * 预览对象(单一对象)
 * @var previewObj - 预览对象
 * @var previewObj.model - 预览模型
 * @var previewObj.member - 预览构件
 *
 */
export let previewObj = {
  model: null,
  member: null,
};
/**
 *
 * 操作对象(多对象)
 * @var operateArr - 预览对象
 * @var operateArr.model - 预览模型
 * @var operateArr.member - 预览构件
 *
 */
export let operateArr = [];
let map;
let counter = 1;

/**
 *
 * 添加/编辑时 用户预览模型
 * @returns { any }
 */
export function addPreviewModel(id) {
  map = Vue.$GLOBAL.map;
  let newMode = map.getLayer(id, "modelId");
  if (
    previewObj.model &&
    previewObj.model != id &&
    map.getLayer(previewObj.model, "modelId")
  ) {
    modelMap.modelAddRemove("remove", previewObj.model, () => {});
  }
  if (newMode) {
    previewObj.model = id;
    return false;
  } else {
    modelMap.modelAddRemove("add", id, () => {
      previewObj.model = id;
    });
  }
}

/**
 *
 * 构件染色
 * @returns { any }
 */
export function componentDyeing(data, modelId, type = "show") {
  let model;
  let color, isTransitionComponent, isComponent, transitionComponent;
  map = Vue.$GLOBAL.map;
  model = map.getLayer(modelId, "modelId");
  if (data.transitionComponent) {
    transitionComponent = data.transitionComponent
      .map((t) => t.component)
      .flat(Infinity);
  } else {
    transitionComponent = [];
  }
  if (type == "show") {
    let timeStamp = 0,
      n = 1;
    model.style = (event) => {
      console.log(event._content);
      // counter += 0.000168;
      // if (Math.round(new Date() / 100) > timeStamp) {
      //   timeStamp = Math.round(new Date() / 100);
      //   counter += 1 / n;
      //   n += 1;
      //   console.log(counter);
      // }
      color = "rgba(255,255,255,0)";
      isTransitionComponent = false;
      isComponent = false;
      try {
        transitionComponent.forEach((e) => {
          if (event.feature.getProperty("name").indexOf(e) >= 0)
            throw new Error();
        });
      } catch (err) {
        isTransitionComponent = true;
      }

      try {
        data.component.forEach((e) => {
          if (event.feature.getProperty("name").indexOf(e) >= 0)
            throw new Error();
        });
      } catch (err) {
        isComponent = true;
      }

      if (isTransitionComponent) {
        color = "rgba(255,0,0,1)";
        // if (parseInt(counter) % 2 == 0) {
        //   color = "rgba(255,0,0,0.1)";
        // } else {
        //   color = "rgba(255,0,0,1)";
        // }
      }

      if (isComponent) {
        color = "rgba(255,255,255,1)";
      }
      return color;
    };
  } else if (type == "hide") {
    model.style = (event) => {
      // counter += 0.000168;
      color = "rgba(255,255,255,1)";
      isTransitionComponent = false;
      isComponent = false;
      try {
        transitionComponent.forEach((e) => {
          if (event.feature.getProperty("name").indexOf(e) >= 0)
            throw new Error();
        });
      } catch (err) {
        isTransitionComponent = true;
      }

      try {
        data.component.forEach((e) => {
          if (event.feature.getProperty("name").indexOf(e) >= 0)
            throw new Error();
        });
      } catch (err) {
        isComponent = true;
      }

      if (isTransitionComponent) {
        color = "rgba(255,0,0,1)";
        // if (parseInt(counter) % 2 == 0) {
        //   color = "rgba(255,0,0,0.1)";
        // } else {
        //   color = "rgba(255,0,0,1)";
        // }
      }

      if (isComponent) {
        color = "rgba(255,255,255,0)";
      }
      return color;
    };
  }
}

/**
 *
 * 开启操作
 * @returns { any }
 */
export function componentStaining(property, id, fn, ...list) {
  let model, operateObj, operateModel;
  map = Vue.$GLOBAL.map;
  model = map.getLayer(id, "modelId");
  // 当前染色对象
  operateModel = operateArr.find((e) => {
    return e.model == id;
  });
  // 没有当前染色对象时
  if (operateModel == undefined) {
    // 判断当前模型是否存在
    if (model) {
      // 有模型的时候 初始化时不删除模型 同时记录模型初始的style 关键字段 init
      operateObj = {
        type: property.type,
        model: property.screenplayId,
        component: [],
        transitionComponent: [
          {
            id: property.id,
            component: property.component,
          },
        ],
        init: model.style,
      };
    } else {
      // 没有模型的时候 初始化时删除模型
      operateObj = {
        type: property.type,
        model: id,
        component: [],
        transitionComponent: [
          {
            id: property.id,
            component: property.component,
          },
        ],
        init: "hide",
      };
    }
    // 最后丢给 operateArr 告诉使用者当前施工模拟上使用了进度条那些数据
    operateArr.push(operateObj);
    if (model) {
      // 当前场景有模型
      componentDyeing(
        {
          component: operateObj.component,
          transitionComponent: operateObj.transitionComponent,
        },
        id,
        operateObj.type
      );
    } else {
      // 当前场景没有模型
      modelMap.modelAddRemove("add", id, (e) => {
        componentDyeing(
          {
            component: operateObj.component,
            transitionComponent: operateObj.transitionComponent,
          },
          id,
          operateObj.type
        );
      });
    }
  } else {
    // 当前染色的构件会继承上一个时间块的数据

    console.log("property", property);

    if (operateModel.type != property.type) {
      let component2 = operateModel.component.filter(
        (item1) => !property.component.some((item2) => item2 === item1)
      );
      operateModel.component = component2;
    }

    // 此处还需考虑其他时间块有没有走完 所以不能单方面替换transitionComponent
    let transitionComponentData = operateModel.transitionComponent.find(
      (item) => item.id == property.id
    );
    if (transitionComponentData) {
      transitionComponentData.component.push(...property.component);
      transitionComponentData.component = Array.from(
        new Set(transitionComponentData.component)
      );
    } else {
      operateModel.transitionComponent.push({
        id: property.id,
        component: property.component,
      });
    }
    componentDyeing(
      {
        component: operateModel.component,
        transitionComponent: operateModel.transitionComponent,
      },
      id,
      operateModel.type
    );
  }
  console.log("operateArr", operateArr);
}

/**
 *
 * 关闭操作
 * @returns { any }
 */

export function reductionStaining(property, id) {
  let operateModel,
    transitionComponentAllData = [],
    transitionComponentData,
    transitionComponentIndex;
  // 当前有记录此时间块
  operateModel = operateArr.find((e) => {
    return e.model == id;
  });
  operateModel.transitionComponent.forEach((item, index) => {
    if (item.id == property.id) {
      transitionComponentIndex = index;
      transitionComponentData = item;
    } else {
      transitionComponentAllData.push(...item.component);
    }
  });

  operateModel.transitionComponent.splice(transitionComponentIndex, 1);

  if (operateModel.component.length == 0) {
    operateModel.component = viewShed.difference(
      transitionComponentData.component,
      transitionComponentAllData
    );
  } else {
    if (property.type == operateModel.type) {
      operateModel.component = componentInheritance(
        operateModel.component,
        viewShed.difference(
          transitionComponentData.component,
          transitionComponentAllData
        )
      );
    }
  }

  componentDyeing(
    {
      component: operateModel.component,
      transitionComponent: operateModel.transitionComponent,
    },
    id,
    operateModel.type
  );
}

/**
 *
 * 初始化
 * @returns { any }
 */
export function init(id) {
  if (id) {
    let tilesetLayer = Vue.$GLOBAL.map.getLayer(id, "modelId");
    tilesetLayer.style = undefined;
  } else {
    /**
     *
     * 施工模拟初始化 会在时间轴 结束后或者重置 触发
     * 会把operateArr所有模型删除
     *
     */
    operateArr.forEach((item) => {
      if (item.init == "hide") {
        modelMap.modelAddRemove("remove", item.model, () => {});
      } else {
        let tilesetLayer = Vue.$GLOBAL.map.getLayer(item.model, "modelId");
        console.log("modelData", tilesetLayer);
        tilesetLayer.style = item.init;
      }
      operateArr = [];
    });
  }
  previewObj = {
    model: null,
    member: null,
  };
}

/**
 *
 * 构件继承
 * @returns { Array }
 */

export function componentInheritance(oldComponent, newComponent) {
  let arr = [...oldComponent, ...newComponent];
  let bufferarr = [];
  let ifBufferarr;
  arr.forEach((element) => {
    bufferarr.length == 0 && bufferarr.push(element);
    ifBufferarr = true;
    try {
      bufferarr.forEach((bufferaele) => {
        if (element.includes(bufferaele)) throw new Error();
      });
    } catch (err) {
      ifBufferarr = false;
    }
    if (ifBufferarr) bufferarr.push(element);
  });
  return bufferarr;
}

/**
 *
 * 根据层级进行排序
 * @returns { any }
 */
function sorting(arr) {
  return arr.sort(function(a, b) {
    return a.split("-").length - b.split("-").length;
  });
}
